/* Home page wave effect */
/* Customized version of liquid by Arturo Moran (https://codepen.io/Armolp/pen/PPbXZx) */

( function( window, document, $ ) {
    'use strict';

    $( document ).ready( function() {

        // Variables
        var canvas = document.getElementById( 'js--home-wave' );

        if ( canvas ) {
            var ctx = canvas.getContext( '2d' ),
                waveHeight,
                aniId;

            // Parameters
            var w = canvas.width = window.innerWidth,
                h = canvas.height,
                fill = false,
                color = '#f8d31c',
                level = 52,
                speed = 50,
                c;

            // Draws the canvas in a loop
            function draw(){
                ctx.clearRect( 0, 0, w, h );
                ctx.fillStyle = color;
                ctx.strokeStyle = color;

                // Draw the liquid
                ctx.beginPath();
                ctx.moveTo( w, h - ( h - 100 ) * level / 100 - 50 );
                ctx.lineTo( w, h );
                ctx.lineTo( 0, h );
                ctx.lineTo( 0, h - ( h - 100 ) * level / 100 - 50 );
                var temp = ( 60 * Math.sin( c * 1 / speed ) );
                ctx.bezierCurveTo( ( w / 3 ), h - ( h - 100 ) * level / 100 - 50 - temp, ( 2 * w / 3 ), h - ( h - 100 ) * level / 100 - 50 + temp, w, h - ( h - 100 ) * level / 100 - 50 );
                ctx.fill();
                update();
                aniId = window.requestAnimationFrame( draw );
            }

            // Update variables
            function update() {
            	c++;
            	if( 100 * Math.PI <= c )
            		c = 0;
            }

            function init() {
            	c = 0;
            	aniId = window.requestAnimationFrame( draw );
            }

            //Update canvas size when resizing the window
            window.addEventListener( 'resize', function() {
                w = canvas.width = window.innerWidth,
                // Restart animation
                window.cancelAnimationFrame( aniId );
                init();
            } );

            // Start animation
            init();
        }

    } );

} )( window, document, jQuery );
